import { captureException } from '@sentry/react';

import { getDescopeError } from './get-descope-error';
import type { DescopeError, DescopeFlowErrorEvent } from '../types';

type DescopeFlow = 'sign-in' | 'sign-up';

type DescopeErrorEvent = string | Event | DescopeFlowErrorEvent | DescopeError;

const getErrorDescription = (
  descopeError: ReturnType<typeof getDescopeError>,
  event: DescopeErrorEvent,
): string => {
  if (descopeError) {
    const parts = [
      'errorCode' in descopeError ? descopeError.errorCode : undefined,
      'code' in descopeError ? descopeError.code : undefined,
      'errorDescription' in descopeError
        ? descopeError.errorDescription
        : undefined,
      'description' in descopeError ? descopeError.description : undefined,
      'errorMessage' in descopeError ? descopeError.errorMessage : undefined,
      'message' in descopeError ? descopeError.message : undefined,
    ].filter((part): part is string => Boolean(part && part.trim()));

    if (parts.length) {
      return [...new Set(parts)].join(' - ');
    }
  }

  if (typeof event === 'string' && event.trim()) {
    return event;
  }

  return 'Unknown error';
};

export const captureDescopeFlowError = (
  flow: DescopeFlow,
  event: DescopeErrorEvent,
): void => {
  const descopeError = getDescopeError(event);
  const description = getErrorDescription(descopeError, event);

  const error = new Error(`Descope ${flow} flow error: ${description}`);
  error.name = 'DescopeFlowError';

  captureException(error, {
    tags: { descope_flow: flow },
    contexts: {
      descope: {
        flow,
        error: descopeError ?? undefined,
      },
    },
  });
};
